import axios, {AxiosResponse} from 'axios';
import {cacheAdapterEnhancer} from 'axios-extensions';
import LRUCache from 'lru-cache';

import environment from '../../configs/environment.config';
import dedupeAdapter from '../adapters/dedupe.adapter';
import {middlewareRequestInterceptor} from '../interceptors/middleware.requestInterceptor';
import {middlewareResponseErrorInterceptor} from '../interceptors/middleware.responseErrorInterceptor';
import {middlewareResponseInterceptor} from '../interceptors/middleware.responseInterceptor';
import qs from "qs";

const tdmMw = axios.create({
    baseURL: `${environment.baseURL}/tdmMW/`,
    adapter: cacheAdapterEnhancer(
        environment.testEnv ? axios.defaults.adapter : dedupeAdapter,
        {
            enabledByDefault: false,
            cacheFlag: 'cache',
            defaultCache: new LRUCache({
                maxAge: environment.cacheMaxAge
            })
        }
    ),
    headers: {
        common: {
            buildTime: environment.buildTime,
            versionNumber:  environment.versionNumber
        }
    },
    paramsSerializer: (params) => qs.stringify(params, {arrayFormat: 'repeat'}),
    responseType: 'json'
});

tdmMw.interceptors.request.use((config) =>
    middlewareRequestInterceptor(require('../../stores/index').store, config)
);

tdmMw.interceptors.response.use(
    (response) =>
        middlewareResponseInterceptor(
            require('../../stores/index').store,
            response
        ) as Promise<AxiosResponse>,
    (response) =>
        middlewareResponseErrorInterceptor(
            require('../../stores/index').store,
            response
        )
);

export default tdmMw;
